export default function InfoPanelDivider(): JSX.Element {
  return (
    <div className="hidden sm:block" aria-hidden="true">
      <div className="py-6 md:py-8">
        <div className="border-t border-gray-200" />
      </div>
    </div>
  );
}
